import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrTotalPlaysByAdResponse } from '@/api/routes/stat/types';

import { fetchAggrTotalPlaysByAd } from './actionCreators';

interface InitialState {
  totalPlaysByAd: AggrTotalPlaysByAdResponse,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  totalPlaysByAd: {},
  isLoading: false,
  error: '',
};

export const aggrTotalPlaysByAdByAdSlice = createSlice({
  name: 'aggrTotalPlaysByAd',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAggrTotalPlaysByAd.fulfilled.type]: (state, action: PayloadAction<AggrTotalPlaysByAdResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.totalPlaysByAd = action.payload;
    },
    [fetchAggrTotalPlaysByAd.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchAggrTotalPlaysByAd.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default aggrTotalPlaysByAdByAdSlice.reducer;
